import React, { useEffect, useState } from "react";
import LexicalEditor from "../../../components/PortalForms/LexicalEditor";
import mammoth from "mammoth";
import download from "downloadjs";
import { useDispatch, useSelector } from "react-redux";
import {
    addWordTemplate, convertDocToDocx, convertHtmlToDocx, convertHtmlToPdf,
    docToDocxConvertedReceived, getDocToDocx, getHtmlToDocx, getHtmlToPdf,
    getWordTempAddedStatus, getWordLoading,
    htmlToDocxConvertedReceived, htmlToPdfConvertedReceived
} from "../../store/wordProccessing";
import { getCurrentUser } from "../../store/auth";
import { getAlert } from "../../../services/appAlerts";

const AddWordTemplate = (props) => {
    const { workflowTask, handleSubmit,
        selectedItem, verSelectedTemp, handleCancel } = props;

    const [content, setContent] = useState("");
    const [templateName, setTemplateName] = useState("");
    const [templateNotes, setTemplateNotes] = useState("");
    const [oldVersion, setOldVersion] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [currentTag, setCurrentTag] = useState("");
    const [importFileName, setImportFileName] = useState("");

    // Local loading states for buttons
    const [isSavingCurrent, setIsSavingCurrent] = useState(false);
    const [isSavingNew, setIsSavingNew] = useState(false);
    const [isExportingWord, setIsExportingWord] = useState(false);
    const [isExportingPdf, setIsExportingPdf] = useState(false);
    const [isImporting, setIsImporting] = useState(false);

    const htmlToPdfSelector = useSelector(getHtmlToPdf);
    const docToDocxSelector = useSelector(getDocToDocx);
    const htmlToDocxSelector = useSelector(getHtmlToDocx);
    const wordTempAddedStatusSelector = useSelector(getWordTempAddedStatus);
    const isLoading = useSelector(getWordLoading);

    const currentUser = getCurrentUser();
    const dispatch = useDispatch();

    // Reset local loading states once API finishes loading
    useEffect(() => {
        if (!isLoading) {
            setIsSavingCurrent(false);
            setIsSavingNew(false);
            setIsExportingWord(false);
            setIsExportingPdf(false);
            setIsImporting(false);
        }
    }, [isLoading]);

    useEffect(() => {
        setImportFileName("");
        if (selectedItem?.id > 0 && !verSelectedTemp) {
            setContent(selectedItem.templateData);
            setTemplateName(selectedItem.templateName);
            setTemplateNotes(selectedItem.notes);
            setOldVersion(false);
        }
        else if (verSelectedTemp?.id > 0) {
            setContent(verSelectedTemp.templateData);
            setTemplateName(verSelectedTemp.templateName);
            setTemplateNotes(verSelectedTemp.notes);
            setOldVersion(true);
        }
        else {
            setContent("");
            setTemplateName("");
            setTemplateNotes("");
            setOldVersion(false);
        }
    }, [selectedItem, verSelectedTemp])

    const handleChange = (newContent) => {
        setContent(newContent);
    };

    const handleGeneratePDF = async () => {
        let html = content;
        html = html.replaceAll('<br>', '<br></br>');
        html = html.replaceAll('</figure>', '</img></figure>');
        html = html.replace('<table', '<table border="1" cellpadding="5" style=" border-collapse: collapse; width: 100%;"');
        const frmData = new FormData();
        frmData.append("html", html);
        dispatch(convertHtmlToPdf(frmData));
    };

    useEffect(() => {
        if (htmlToPdfSelector?.size > 0) {
            const url = window.URL.createObjectURL(htmlToPdfSelector);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            dispatch(htmlToPdfConvertedReceived(null));
        }
    }, [htmlToPdfSelector])

    const handleImportDocs = async ({ target }) => {
        if (target.files.length > 0) {
            let docData = target.files[0].arrayBuffer();
            if (target.files[0].name?.split('.').pop() === "doc") {
                var frmData = new FormData()
                frmData.append("files", target.files[0]);
                dispatch(convertDocToDocx(frmData));
            }
            else {
                mammoth.convertToHtml({ arrayBuffer: docData })
                    .then(function (result) {
                        var html = result.value;
                        var messages = result.messages;
                        console.log(html);
                        setContent(html);
                        setIsImporting(false);
                    })
                    .catch(function (error) {
                        console.error(error);
                        setIsImporting(false);
                    });
            }

        }
    }

    useEffect(() => {
        if (docToDocxSelector) {
            mammoth.convertToHtml({ arrayBuffer: docToDocxSelector })
                .then(function (result) {
                    var html = result.value;
                    var messages = result.messages;
                    setContent(html);
                })
                .catch(function (error) {
                    console.error(error);
                });
            dispatch(docToDocxConvertedReceived(null));
        }
    }, [docToDocxSelector])

    const handleGenerateHtmlToDocx = async () => {
        var frmData = new FormData()
        frmData.append("html", content);
        dispatch(convertHtmlToDocx(frmData));
    }

    useEffect(() => {
        if (htmlToDocxSelector) {
            const mimeType =
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            download(htmlToDocxSelector, `HtmlToDocxExport.docx`, mimeType);
            dispatch(htmlToDocxConvertedReceived(null));
        }
    }, [htmlToDocxSelector]);

    const SaveNewVersion = (type) => {
        const temp = {
            "ciid": workflowTask.ciid,
            "wiid": workflowTask.wiid,
            "iiid": workflowTask.iiid,
            "senderId": workflowTask.performerId,
            "templateId": 0,
            "templateType": "Word",
            "templateName": templateName,
            "notes": templateNotes,
            "templateData": content,
            "version": 1,
            "createdBy": currentUser.id
        }
        if (selectedItem?.id > 0) {
            temp.id = selectedItem.id;
            temp.createdDateTime = selectedItem.createdDateTime;
        }

        if (selectedItem?.id > 0 && type === "new") {
            temp.id = 0;
            temp.version = selectedItem.version + 1;
            if (selectedItem.templateId > 0)
                temp.templateId = selectedItem.templateId;
            else
                temp.templateId = selectedItem.id;
        }

        const frmData = new FormData();
        frmData.append("template", JSON.stringify(temp));
        dispatch(addWordTemplate(frmData))
        setTemplateName("")
        setTemplateNotes("")
        setCurrentTag("")
        setContent("")
        setSelectedTags([])
    }

    useEffect(() => {
        if (wordTempAddedStatusSelector) {

            if (selectedItem?.id > 0)
                getAlert("", "Updated Successfully", "success");
            else
                getAlert("", "Added Successfully", "success");

            handleSubmit();
        }
    }, [wordTempAddedStatusSelector]);


    const handleAddTag = (tag) => {
        const trimmed = tag.trim();
        if (trimmed && !selectedTags.includes(trimmed)) {
            setSelectedTags([...selectedTags, trimmed]);
        }
    };

    const handleRemoveTag = (indexToRemove) => {
        setSelectedTags(selectedTags.filter((_, index) => index !== indexToRemove));
    };

    const handleTagInputKeyDown = (e) => {
        if (e.key === "Enter" || e.key === "," || e.key === "Tab" || e.key === " ") {
            e.preventDefault();
            const trimmed = currentTag.trim();
            if (trimmed) {
                handleAddTag(trimmed);
                setCurrentTag("");
            }
        } else if (e.key === "Backspace" && !currentTag) {
            setSelectedTags(selectedTags.slice(0, -1));
        }
    };



    const onCancel = handleCancel || handleSubmit;

    return (
        <div className="rt-add-word-container">
            <style>{`
              .rt-add-word-container {
                max-width: 100% !important;
                margin: 0 0 12px 0 !important;
                background: #ffffff;
                border: 1px solid #e2e8f0;
                border-radius: 14px;
                padding: 20px 24px;
                box-shadow: 0 10px 15px -3px rgba(0,0,0,0.03), 0 4px 6px -2px rgba(0,0,0,0.03);
              }
              .rt-add-form-header {
                margin-bottom: 18px;
                border-bottom: 1px solid #f1f5f9;
                padding-bottom: 12px;
              }
              .rt-add-form-header h2 {
                font-size: 16px !important;
                font-weight: 700 !important;
                color: #0f172a !important;
                margin: 0 0 4px 0 !important;
                display: flex;
                align-items: center;
                gap: 8px;
              }
              .rt-add-form-header p {
                font-size: 12.5px !important;
                color: #64748b !important;
                margin: 0 !important;
                line-height: 1.4;
              }
              .rt-add-word-container .form-control {
                border: 1.5px solid #cbd5e1 !important;
                border-radius: 9px !important;
                font-size: 13.5px !important;
                padding: 10px 14px 10px 38px !important;
                height: auto !important;
                color: #1e293b !important;
                background-color: #ffffff !important;
                box-shadow: 0 1px 2px 0 rgba(0,0,0,0.02) !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
              }
              .rt-add-word-container .form-control:focus {
                border-color: #2563eb !important;
                box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
                background-color: #fafbff !important;
              }
              .rt-add-word-container #txtDocName,
              .rt-add-word-container #txtDocNotes {
                padding-left: 38px !important;
              }
              .rt-add-word-container .form-control-label,
              .rt-add-word-container label {
                font-size: 12.5px !important;
                font-weight: 700 !important;
                color: #475569 !important;
                margin-bottom: 6px !important;
                text-transform: none !important;
                letter-spacing: normal !important;
              }
              .rt-add-word-container .form-group {
                margin-bottom: 12px !important;
              }
              .rt-add-word-container .wf-input-wrap {
                position: relative !important;
                width: 100% !important;
              }
              .rt-add-word-container .wf-input-wrap .wf-input-icon {
                position: absolute !important;
                left: 12px !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                color: #94a3b8 !important;
                font-size: 13px !important;
                pointer-events: none !important;
                z-index: 10 !important;
              }
              .rt-add-word-container .wf-input-wrap:has(textarea) .wf-input-icon {
                top: 14px !important;
                transform: none !important;
              }
              .rt-add-word-container .form-group.required .form-control-label::after,
              .rt-add-word-container .form-group.required label::after {
                content: " *" !important;
                color: #ef4444 !important;
                font-weight: bold !important;
              }
              .rt-add-word-container textarea.form-control {
                min-height: 90px !important;
                resize: vertical !important;
              }
              
              .rt-file-upload-wrap {
                position: relative;
                overflow: hidden;
                display: inline-block;
                width: 100%;
              }
              .rt-file-upload-btn {
                border: 2px dashed #cbd5e1 !important;
                background: #f8fafc !important;
                padding: 24px 16px !important;
                border-radius: 12px !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 8px !important;
                font-size: 13px !important;
                color: #475569 !important;
                cursor: pointer !important;
                transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
                width: 100% !important;
                text-align: center !important;
              }
              .rt-file-upload-btn i {
                font-size: 26px !important;
                color: #2563eb !important;
                transition: transform 0.2s ease !important;
              }
              .rt-file-upload-wrap:hover .rt-file-upload-btn {
                border-color: #2563eb !important;
                background: #eff6ff !important;
                box-shadow: 0 4px 12px -2px rgba(37,99,235,0.08) !important;
              }
              .rt-file-upload-wrap:hover .rt-file-upload-btn i {
                transform: translateY(-2px) !important;
              }
              .rt-file-upload-btn-text-main {
                font-weight: 700 !important;
                color: #1e293b !important;
                font-size: 13.5px !important;
              }
              .rt-file-upload-btn-text-sub {
                font-weight: 500 !important;
                color: #64748b !important;
                font-size: 11px !important;
              }
              .rt-file-upload-wrap input[type=file] {
                font-size: 100px;
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                cursor: pointer;
                width: 100%;
                height: 100%;
              }

              /* Rich LexicalEditor reskin */
              .rt-add-word-container .lexical-editor-container {
                border-radius: 12px !important;
                border: 1.5px solid #cbd5e1 !important;
                box-shadow: 0 4px 12px -2px rgba(15,23,42,0.03), 0 2px 4px -1px rgba(15,23,42,0.02) !important;
                overflow: hidden !important;
                transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
              }
              .rt-add-word-container .lexical-editor-container:focus-within {
                border-color: #2563eb !important;
                box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 4px 12px -2px rgba(15,23,42,0.03) !important;
              }
              .rt-add-word-container .editor-input {
                min-height: 250px !important;
                max-height: 1200px !important;
                resize: vertical !important;
                overflow: auto !important;
              }

              .rt-add-word-container .btn-save-form {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 8px !important;
                background: #2563eb !important;
                color: #ffffff !important;
                border: 1px solid #2563eb !important;
                padding: 10px 24px !important;
                border-radius: 9px !important;
                font-size: 13.5px !important;
                font-weight: 600 !important;
                cursor: pointer !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                outline: none !important;
                box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.15) !important;
              }
              .rt-add-word-container .btn-save-form:hover {
                background: #1d4ed8 !important;
                border-color: #1d4ed8 !important;
                transform: translateY(-1.5px) !important;
                box-shadow: 0 6px 12px -1px rgba(37, 99, 235, 0.25) !important;
              }
              .rt-add-word-container .btn-save-form:active {
                transform: translateY(0) !important;
              }
              .rt-add-word-container .btn-save-form.btn-save-current {
                background: #059669 !important;
                border-color: #059669 !important;
                box-shadow: 0 4px 6px -1px rgba(5, 150, 105, 0.15) !important;
              }
              .rt-add-word-container .btn-save-form.btn-save-current:hover {
                background: #047857 !important;
                border-color: #047857 !important;
                box-shadow: 0 6px 12px -1px rgba(5, 150, 105, 0.25) !important;
              }
              .rt-add-word-container .btn-cancel-form {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 8px !important;
                background: #ffffff !important;
                color: #475569 !important;
                border: 1.5px solid #cbd5e1 !important;
                padding: 10px 24px !important;
                border-radius: 9px !important;
                font-size: 13.5px !important;
                font-weight: 600 !important;
                cursor: pointer !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                outline: none !important;
              }
              .rt-add-word-container .btn-cancel-form:hover {
                background: #f8fafc !important;
                color: #0f172a !important;
                border-color: #94a3b8 !important;
                transform: translateY(-1.5px) !important;
              }
              .rt-add-word-container .btn-cancel-form:active {
                transform: translateY(0) !important;
              }

              /* Custom Tags Input Styling */
              .rt-add-word-container .wf-tags-input-wrap {
                border: 1.5px solid #cbd5e1 !important;
                border-radius: 9px !important;
                background-color: #ffffff !important;
                padding: 6px 12px 6px 38px !important;
                position: relative !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                min-height: 43px !important;
                display: flex !important;
                align-items: center !important;
                flex-wrap: wrap !important;
                gap: 6px !important;
              }
              .rt-add-word-container .wf-tags-input-wrap:focus-within {
                border-color: #2563eb !important;
                box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
              }
              .rt-add-word-container .wf-tags-input-wrap .wf-input-icon {
                position: absolute !important;
                left: 12px !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                color: #94a3b8 !important;
                font-size: 13px !important;
                pointer-events: none !important;
                z-index: 10 !important;
                transition: color 0.2s ease !important;
              }
              .rt-add-word-container .wf-tags-input-wrap:focus-within .wf-input-icon {
                color: #2563eb !important;
              }
              
              /* Custom Tag Badges */
              .rt-add-word-container .wf-custom-tag {
                display: inline-flex !important;
                align-items: center !important;
                gap: 6px !important;
                background-color: #eff6ff !important;
                border: 1px solid rgba(37, 99, 235, 0.18) !important;
                border-radius: 6px !important;
                color: #1d4ed8 !important;
                font-weight: 600 !important;
                font-size: 12.5px !important;
                padding: 3px 8px !important;
                transition: all 0.2s ease !important;
                user-select: none !important;
              }
              .rt-add-word-container .wf-custom-tag:hover {
                background-color: #dbeafe !important;
                color: #1e40af !important;
              }
              .rt-add-word-container .wf-custom-tag-delete {
                cursor: pointer !important;
                color: #3b82f6 !important;
                font-size: 14px !important;
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                transition: color 0.15s ease !important;
              }
              .rt-add-word-container .wf-custom-tag-delete:hover {
                color: #ef4444 !important;
              }
              
              /* The input field inside the tags wrap */
              .rt-add-word-container .rt-equal-height-row .wf-tags-input-wrap input.wf-tags-custom-input {
                border: none !important;
                outline: none !important;
                box-shadow: none !important;
                background: transparent !important;
                font-size: 13.5px !important;
                color: #1e293b !important;
                padding: 4px 0 !important;
                flex-grow: 1 !important;
                min-width: 120px !important;
                height: auto !important;
              }
              .rt-add-word-container .rt-equal-height-row .wf-tags-input-wrap input.wf-tags-custom-input:focus {
                border: none !important;
                outline: none !important;
                box-shadow: none !important;
                background: transparent !important;
              }
              .rt-add-word-container .rt-equal-height-row .wf-tags-input-wrap input.wf-tags-custom-input.w-100 {
                width: 100% !important;
                flex: 1 1 100% !important;
              }
              
              .rt-add-word-container .btn-group {
                position: relative;
                display: inline-flex;
                vertical-align: middle;
              }
              .rt-add-word-container .dropdown-menu {
                border-radius: 12px !important;
                border: 1px solid #e2e8f0 !important;
                box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
                padding: 8px !important;
                background: #ffffff !important;
                margin-top: 6px !important;
              }
              .rt-add-word-container .dropdown-item {
                border-radius: 8px !important;
                font-size: 13px !important;
                font-weight: 550 !important;
                color: #475569 !important;
                padding: 8px 12px !important;
                transition: all 0.15s ease !important;
                cursor: pointer !important;
                width: 100%;
                text-align: left;
                background: transparent;
                border: none;
                display: flex;
                align-items: center;
                gap: 8px;
              }
              .rt-add-word-container .dropdown-item:hover {
                background-color: #eff6ff !important;
                color: #2563eb !important;
              }
              
              /* Export buttons */
              .rt-add-word-container .rt-msg-action-btn {
                display: inline-flex !important;
                align-items: center !important;
                gap: 8px !important;
                background: #ffffff !important;
                border: 1.5px solid #cbd5e1 !important;
                padding: 10px 16px !important;
                border-radius: 9px !important;
                font-size: 13px !important;
                font-weight: 600 !important;
                color: #475569 !important;
                cursor: pointer !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                outline: none !important;
                white-space: nowrap !important;
              }
              .rt-add-word-container .rt-msg-action-btn:hover {
                background: #f8fafc !important;
                color: #0f172a !important;
                border-color: #94a3b8 !important;
                transform: translateY(-1.5px) !important;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
              }
              
              /* Equal Height Row for Tags & Notes */
              .rt-add-word-container .rt-equal-height-row {
                display: flex !important;
                flex-wrap: wrap !important;
              }
              .rt-add-word-container .rt-equal-height-row .col-md-6 {
                display: flex !important;
                flex-direction: column !important;
              }
              .rt-add-word-container .rt-equal-height-row .form-group {
                display: flex !important;
                flex-direction: column !important;
                flex: 1 !important;
                margin-bottom: 12px !important;
              }
              .rt-add-word-container .rt-equal-height-row .wf-input-wrap {
                flex: 1 !important;
                display: flex !important;
                flex-direction: column !important;
              }
              .rt-add-word-container .rt-equal-height-row textarea.form-control {
                flex: 1 !important;
                height: 100% !important;
                min-height: 90px !important;
              }
              .rt-add-word-container .rt-equal-height-row .wf-tags-input-wrap {
                flex: 1 !important;
                min-height: 90px !important;
                align-content: flex-start !important;
                flex-direction: row !important;
                flex-wrap: wrap !important;
              }
            `}</style>

            <div className="rt-add-form-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px", borderBottom: "1px solid #f1f5f9", paddingBottom: "12px" }}>
                <div>
                    <h2>
                        <i className={`fa ${selectedItem?.id > 0 ? "fa-pencil-square-o" : "fa-plus-circle"}`} aria-hidden="true" style={{ color: "#2563eb" }}></i>
                        {oldVersion ? "View Version History Case Report" : selectedItem?.id > 0 ? "Edit Case Report" : "Add Case Report"}
                    </h2>
                    <p style={{ margin: 0 }}>
                        {oldVersion 
                            ? `Viewing previous version V${verSelectedTemp?.version} of report "${templateName}".`
                            : selectedItem?.id > 0 
                                ? `Update configuration, tags, and document content for "${templateName}".`
                                : "Create a new customized text agreement, engagement letter, or case report template."
                        }
                    </p>
                </div>
                {!oldVersion && (
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <div style={{ position: "relative", overflow: "hidden" }}>
                            <button className="rt-msg-action-btn" type="button" disabled={isLoading}>
                                {isImporting ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin" aria-hidden="true" style={{ color: "#2563eb" }}></i>
                                        Importing...
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-cloud-upload" aria-hidden="true" style={{ color: "#2563eb" }}></i>
                                        {importFileName ? `Imported: ${importFileName}` : "Import Docx"}
                                    </>
                                )}
                            </button>
                            {!isImporting && (
                                <input type="file" id="importDocxHeader" title="Import From Docx"
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        opacity: 0,
                                        cursor: "pointer",
                                        width: "100%",
                                        height: "100%"
                                    }}
                                    onChange={(e) => {
                                        if (e.target.files.length > 0) {
                                            setIsImporting(true);
                                            setImportFileName(e.target.files[0].name);
                                            handleImportDocs(e);
                                        }
                                    }} 
                                />
                            )}
                        </div>
                        <button 
                            className="rt-msg-action-btn" 
                            type="button" 
                            onClick={() => {
                                setIsExportingWord(true);
                                handleGenerateHtmlToDocx();
                            }}
                            disabled={isLoading}
                        >
                            {isExportingWord ? (
                                <>
                                    <i className="fa fa-spinner fa-spin" aria-hidden="true" style={{ color: "#2b579a" }}></i>
                                    Exporting...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-file-word-o" aria-hidden="true" style={{ color: "#2b579a" }}></i> Export Word
                                </>
                            )}
                        </button>
                        <button 
                            className="rt-msg-action-btn" 
                            type="button" 
                            onClick={() => {
                                setIsExportingPdf(true);
                                handleGeneratePDF();
                            }}
                            disabled={isLoading}
                        >
                            {isExportingPdf ? (
                                <>
                                    <i className="fa fa-spinner fa-spin" aria-hidden="true" style={{ color: "#ac1b1b" }}></i>
                                    Exporting...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-file-pdf-o" aria-hidden="true" style={{ color: "#ac1b1b" }}></i> Export PDF
                                </>
                            )}
                        </button>
                    </div>
                )}
            </div>

            <div className="row">
                <div className="col-md-12" style={{ marginBottom: "20px" }}>
                    <LexicalEditor
                        value={content}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="form-group required">
                        <label htmlFor="txtDocName" className="form-control-label">Document Name</label>
                        <div className="wf-input-wrap">
                            <i className="fa fa-file-text wf-input-icon" aria-hidden="true"></i>
                            <input type="text" placeholder="Document Name"
                                className="form-control" id="txtDocName" name="txtDocName"
                                style={{ paddingLeft: "38px" }}
                                value={templateName} onChange={({ currentTarget }) => setTemplateName(currentTarget.value)} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row rt-equal-height-row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtDocTag">
                            Document Tags
                        </label>
                        <div className="wf-input-wrap wf-tags-input-wrap">
                            <i className="fa fa-tags wf-input-icon" aria-hidden="true"></i>
                            {selectedTags.map((tag, index) => (
                                <span className="wf-custom-tag" key={index}>
                                    {tag}
                                    <span 
                                        className="wf-custom-tag-delete" 
                                        onClick={() => handleRemoveTag(index)}
                                        title="Remove tag"
                                    >
                                        <i className="fa fa-times-circle" aria-hidden="true"></i>
                                    </span>
                                </span>
                            ))}
                            <input
                                type="text"
                                className={`wf-tags-custom-input ${selectedTags.length === 0 ? "w-100" : ""}`}
                                id="txtDocTag"
                                placeholder={selectedTags.length === 0 ? "Add a tag..." : ""}
                                value={currentTag}
                                onChange={(e) => setCurrentTag(e.target.value)}
                                onKeyDown={handleTagInputKeyDown}
                                onBlur={() => {
                                    const trimmed = currentTag.trim();
                                    if (trimmed) {
                                        if (!selectedTags.includes(trimmed)) {
                                            setSelectedTags([...selectedTags, trimmed]);
                                        }
                                        setCurrentTag("");
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="txtDocNotes" className="form-control-label">Document Notes</label>
                        <div className="wf-input-wrap">
                            <i className="fa fa-pencil wf-input-icon" aria-hidden="true" style={{ top: "14px", transform: "none" }}></i>
                            <textarea placeholder="Document Notes"
                                className="form-control" id="txtDocNotes" name="txtDocNotes"
                                style={{ paddingLeft: "38px", height: "100%", minHeight: "90px" }}
                                value={templateNotes} onChange={({ currentTarget }) => setTemplateNotes(currentTarget.value)} />
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "16px", marginTop: "18px", width: "100%", flexWrap: "wrap" }}>
                <button className="btn-cancel-form" type="button" onClick={onCancel} style={{ minWidth: "160px", justifyContent: "center" }}>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i> Back to Reports
                </button>

                {!oldVersion && (
                    <>
                        <button 
                            className="btn-save-form btn-save-current" 
                            type="button" 
                            onClick={() => {
                                setIsSavingCurrent(true);
                                SaveNewVersion("");
                            }} 
                            style={{ minWidth: "180px", justifyContent: "center" }}
                            disabled={isLoading}
                        >
                            {isSavingCurrent ? (
                                <>
                                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Saving...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-pencil" aria-hidden="true"></i> Save Current Version
                                </>
                            )}
                        </button>
                        <button 
                            className="btn-save-form" 
                            type="button" 
                            onClick={() => {
                                setIsSavingNew(true);
                                SaveNewVersion("new");
                            }} 
                            style={{ minWidth: "180px", justifyContent: "center" }}
                            disabled={isLoading}
                        >
                            {isSavingNew ? (
                                <>
                                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Saving...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-plus-circle" aria-hidden="true"></i> Save New Version
                                </>
                            )}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

export default AddWordTemplate;